import React from "react";

import FollowUpItem from "./FollowUpItem";

const FollowUpList = ({ listOfItems, label, actionType, actionTypeList }) => {
  return (
    <div id="Follow-Up-List" data-testid="Follow-Up-List">
      {actionType !== actionTypeList?.provider?.key && (
        <FollowUpItem
          key={"follow-up-item_" + listOfItems[actionType]?.id}
          id={listOfItems[actionType]?.id}
          config={listOfItems[actionType]}
          label={label}
          actionType={actionType}
          actionTypeList={actionTypeList}
        />
      )}
      {actionType === actionTypeList?.provider?.key && (
        <div className="max-h-[10vh] overflow-y-auto bg-white px-1 [&::-webkit-scrollbar-thumb]:bg-purple-600 [&::-webkit-scrollbar]:[width:10px]">
          {Object.keys(listOfItems).map((item) => (
            <div
              className="mb-2 border-y border-solid border-white"
              key={"follow-up-item_" + listOfItems[item].id}
            >
              <FollowUpItem
                id={listOfItems[item].id}
                config={listOfItems[item]}
                label={listOfItems[item].provider.name}
                actionType={actionType}
                actionTypeList={actionTypeList}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FollowUpList;
